export default {
  props: {
    disabled: Boolean,
    name: {
      type: String,
      required: true,
    },
    required: Boolean,
    placeholder: String,
    maxLength: Number,
    modelValue: String,
    validator: String,
  },
  emits: ['blur', 'focus', 'update:modelValue'],
  data() {
    return {
      focus: false,
    };
  },
  computed: {
    textAreaModifiers() {
      return {
        'textarea--has-value': this.modelValue,
        'textarea--is-focused': this.focus,
      };
    },
  },
  methods: {
    handleBlur(e) {
      this.focus = false;
      this.$emit('blur', e.target.name);
    },
    handleFocus(e) {
      this.focus = true;
      this.$emit('focus', e.target.name);
    },
    updateValue(e) {
      this.$emit('update:modelValue', e.target.value);
    },
  },
};
